/* eslint-disable no-unused-vars */
import { DateRangePicker } from '@syncfusion/ej2-calendars';
import Moment from 'moment';
import React, { useEffect, useState, useContext } from 'react';
import SelectSearch, { fuzzySearch } from "react-select-search";
import { getCurrentWeekDate, getSelectedCurrentWeekDate } from '../service/utilService';
import { getPlaza } from '../common/apiService';
import MultiSelect from './MultiSelect';
import { UserContext } from "../contexts/UserContext";



export default function PlazAndDateRangePicker({ plazaClassName, datepickerClassName, setjsonData, showDateRangePicker=true, showPlaza=true, showVioCreationDate=false }) {

    const [dateType, setDateType] = useState("");
    const [isSpUser, setIsSpUser] = useState(false);
    const [dateArr, setDateArr] = useState([getCurrentWeekDate().split(" - ")[0] + "T00:00:00.00Z", getCurrentWeekDate().split(" - ")[1] + "T23:59:59.00Z"])
    const [tollPlazaData, setTollPlaza] = useState([]);
    const [plaza, setPlaza] = useState(sessionStorage.selectedplaza ? sessionStorage.selectedplaza : '');
    const userDetail = useContext(UserContext);


    let daterangeObject = new DateRangePicker({
        placeholder: 'Select date  range',
        presets: [
            { label: 'Reader Read Time', start: new Date(), end: new Date() },
            { label: 'Processing Time', start: new Date(), end: new Date() },
        ]
    });
    useEffect(() => {
            const spUser = userDetail.userType === 'SP'
            setIsSpUser(spUser);
    }, [userDetail])

    useEffect(() => {
        const sltDateType = (sessionStorage.selecteddatetype === 'ViolationCreationDate' && !showVioCreationDate) ? "ReaderReadTime" : (sessionStorage.selecteddatetype || "ReaderReadTime")
        setDateType(sltDateType);
        sessionStorage.selecteddatetype = sltDateType;

        document.onclick = keyDownEvent;
        setTimeout(()=>document.getElementById("daterangepickerid").value = getSelectedCurrentWeekDate(),0);

        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        document.onclick = keyDownEvent;
        const headerjson = {
            plaza:userDetail.plaza
        }
        getPlaza(headerjson).then(res => {
           const plaza = userDetail.plaza;
           const transformed = res.data.map(({ plazaId, plazaName }) => ({ value: plazaId, label: plazaId + "-" + (plazaName.toLowerCase() || '--')}));
           transformed.sort((a,b)=>a.value - b.value);
            transformed.unshift({ label: "All", value: "*" });
            setTollPlaza(transformed);
            document.getElementById("daterangepickerid").value =  getSelectedCurrentWeekDate();

        }).catch(err => {
        });
    }, [userDetail])
    

    const [clickElement, setClickElement] = useState("btn");

    const keyDownEvent = (evt) => {
        if (evt.target.tagName !== "LABEL" && evt.target.tagName !== "INPUT") {
            if (document.getElementById("daterangepickerid"))
                document.getElementById("daterangepickerid").blur();
            setClickElement("btn");
        } else {
            setClickElement("label");
            let len = document.getElementsByClassName("e-cell").length;
            for (let i = 0; i < len; i++) {
                if (document.getElementsByClassName("e-cell")[i]) {
                    document.getElementsByClassName("e-apply")[0].disabled = true;
                    document.getElementsByClassName("e-cell")[i].classList.remove("e-selected");
                    document.getElementsByClassName("e-cell")[i].classList.remove("e-start-date");
                    document.getElementsByClassName("e-cell")[i].classList.remove("e-range-hover");
                }
            }
        }
    }

    const setPlazadata = (val) => {
        sessionStorage.setItem("selectedplaza", val);
        setPlaza(val ? val : userDetail.plaza,)
        const plazaList = val ? val : userDetail.plaza
        const json = {
            plazaIds: plazaList.includes("*") && isSpUser ? '""' : plazaList,
            startDate: dateArr[0],
            endDate: dateArr[1],
            dateType: dateType,
        }
        setjsonData(json);
    }

    const [previousSelectedDate, setpreviousSelectedDate] = useState("")
    const setDate = (dates) => {
        sessionStorage.selecteddate = dates;
        sessionStorage.selecteddatetype = dateType;
        if (!previousSelectedDate) {
            setpreviousSelectedDate(dates + "" + dateType);
        } else if (previousSelectedDate !== dates + "" + dateType && clickElement === 'btn') {
            setpreviousSelectedDate(dates + "" + dateType);
            var date = new Date(dates.split(" - ")[0]);
            const plazaList = plaza ? plaza : ( userDetail.plaza || [])
            if (dates) {
                const json = {
                    plazaIds: plazaList.includes("*") && isSpUser ? '""' : plazaList,
                    startDate: Moment(dates.split(" - ")[0]).format("YYYY-MM-DD") + "T00:00:00.00Z",
                    endDate: Moment(dates.split(" - ")[1]).format("YYYY-MM-DD") + "T23:59:59.00Z",
                    DateType: dateType,
                }
                setjsonData(json);
                setDateArr([Moment(dates.split(" - ")[0]).format("YYYY-MM-DD") + "T00:00:00.00Z", Moment(dates.split(" - ")[1]).format("YYYY-MM-DD") + "T23:59:59.00Z" ]) ;
            }
        }
    }


    const [change, setChange] = useState(false);
    useEffect(() => {
        daterangeObject.appendTo("#daterangepickerid");
        document.getElementsByClassName("e-range-icon")[0].addEventListener('click', (evt) => {
            setChange(oldvalue => !oldvalue);
            if (document.getElementById("daterangepickerid_options")) {
                let html = `<ul class="e-list-parent e-ul " role="listbox" aria-hidden="false" id="daterangepickerid_options"><li class="e-list-item e-active" id="custom_range">Select Date Type</li><li class="e-list-item" id="custom_range"><label><input type="radio" name="type" value="ReaderReadTime" id="rrt"> Reader Read Date</label> </li><li class="e-list-item" id="custom_range"><label><input type="radio" name="type" value="ProcessingTime" id="pt"> Processing Date</label> </li>`
                if(showVioCreationDate) html += `<li class="e-list-item" id="custom_range"><label><input type="radio" name="type" value="ViolationCreationDate" id="vcd">Violation Creation Date</label> </li>`;
                html += "</ul>"
                document.getElementById("daterangepickerid_options").innerHTML = html;
                document.querySelector("#daterangepickerid_options").addEventListener('click', function (event) {
                    if (event.target && event.target.matches("input[type='radio']")) {
                        setDateType(document.querySelector("input[type=radio][name=type]:checked").value)
                    }
                });
            }
        })
        document.getElementById("daterangepickerid").value = "";
        // eslint-disable-next-line
    }, [])


    useEffect(() => {
        if (dateType === 'ReaderReadTime' || (dateType === 'ViolationCreationDate' && !showVioCreationDate)) {
            if (document.getElementById("rrt")) {
                document.getElementById("rrt").checked = true;
            }
        } else if(dateType === 'ProcessingTime') {
            if (document.getElementById("pt")) {
                document.getElementById("pt").checked = true;
            }
        } else {
            if (document.getElementById("vcd")) {
                document.getElementById("vcd").checked = true;
            }
        }
        // eslint-disable-next-line 
    }, [change])


    return (
        <>
        <div
        className={datepickerClassName}
        style={{ display: showDateRangePicker ? "block" : "none" }}
      >
        <input
          id="daterangepickerid"
          type="text"
          onBlur={(e) => setDate(e.target.value)}
        />
      </div>
      {showPlaza && (
        <div className={plazaClassName} style={{ padding: 0 }}>
          <div className="plazzalov">
            <MultiSelect
              options={tollPlazaData}
              onChange={setPlazadata}
              selectedValue={plaza}
            />
          </div>
        </div>
      )}
        </>
    )
}
